(function (angular) {
  "use strict";

  angular.module("app").service("MessagePostsApi", messagePostsApi);

  messagePostsApi.$inject = ["$resource", "settings"];

  function messagePostsApi($resource, settings) {
    /**
     * Adds any additional parameters to the resource
     * @return {this}
     */
    function transform() {
      return this;
    }

    var resource = $resource(
      settings.apiBase + "/message-posts",
      {},
      {
        get: {
          method: "GET",
          params: {
            message_thread_id: null,
          },
          responseType: "json",
          transformResponse: function (response) {
            if (typeof response === "string") {
              response = JSON.parse(response);
            }

            if (Array.isArray(response.data)) {
              angular.forEach(response.data, function (post) {
                transform.call(post);
              });
            } else {
              if (response.data) {
                transform.call(response.data);
              }
            }

            return response;
          },
        },
      },
    );
    resource.prototype.transform = transform;

    return resource;
  }
})(angular);
